module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.msg) + "\n  "), _c('div', {
    staticClass: "task-bar",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("./../assets/start_logo.png")
    },
    on: {
      "click": _vm.onStartup
    }
  })]), _vm._v(" "), _c('SearchBar')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d0b896d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskBar.vue
// module id = 150
// module chunks = 1